/**
 * Props for the QuoteError component
 */
interface QuoteErrorProps {
  /** The error message to display */
  error: string;
}

/**
 * Displays an error message in terminal-style format when quote loading fails
 * 
 * @param props - The component props
 * @returns A formatted error message with terminal styling
 */
function QuoteError({ error }: QuoteErrorProps) {
  return (
    <div data-testid="quote-error">
      <p className="text-red-400" data-testid="error-message">
        <span className="text-brand-text">$&nbsp;</span>[error] Failed to load
        quote: {error}
      </p>
    </div>
  );
}

export default QuoteError;
